<router-outlet></router-outlet>
<app-screen-loader *ngIf="loaderService.loading$ | async" class="z-[2000]"></app-screen-loader>